import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Textarea } from "@/components/elements/Textarea";
import { Typography } from "@mui/material";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { TPartnerForm } from "@/features/talent/types/partnerForm";
import { divider } from "@/theme/colors";

type TPartnerAdditionalInfoFormProps = {
  readonly?: boolean;
};

export const PartnerAdditionalInfoForm: FC<TPartnerAdditionalInfoFormProps> = ({ readonly }) => {
  const { control } = useFormContext<TPartnerForm>();

  return (
    <InnerBox title={<Typography variant="sub16Bold">その他の情報</Typography>} showDivider={false} borderColor={divider.high} sx={{ gap: "24px" }}>
      <FormField control={control} name="memo">
        <Textarea readonly={readonly} />
      </FormField>
    </InnerBox>
  );
};
